import React from "react";

const ManageDriverList = () => {
  return <div>ManageDriverList</div>;
};

export default ManageDriverList;
